import { Navigate } from 'react-router-dom';
import { gettoken } from 'functions/gettabconfig';

function PrivateAdmin(props){
    const logadoa = gettoken() ? true : false;  
    return logadoa ? props.children : <Navigate to='/admin/login' />;
}

export default PrivateAdmin;